export default __webpack_public_path__ + "static/media/sticky-printer.0b3d6667.svg";